import type {FarrowingCountsRecord} from '../lib/pigFarrowBatch.js';

export type FarrowingRecord = FarrowingCountsRecord & {
  id?: string;
  sire?: string | null;
  exposureStart?: string | null;
  exposureEnd?: string | null;
  motheringQuality?: string | null;
  demeanor?: string | null;
  location?: string | null;
  wentWell?: string | null;
  didntGoWell?: string | null;
  defects?: string | null;
};

export type FarrowForm = {
  sow: string;
  group: string;
  farrowingDate: string;
  exposureStart: string;
  exposureEnd: string;
  sire: string;
  motheringQuality: string;
  demeanor: string;
  totalBorn: number | string;
  deaths: number | string;
  location: string;
  wentWell: string;
  didntGoWell: string;
  defects: string;
};

export function farrowingFormFor(record: FarrowingRecord): FarrowForm {
  return {
    sow: String(record.sow ?? ''),
    group: String(record.group ?? ''),
    farrowingDate: record.farrowingDate || '',
    exposureStart: record.exposureStart || '',
    exposureEnd: record.exposureEnd || '',
    sire: record.sire || '',
    motheringQuality: record.motheringQuality || '',
    demeanor: record.demeanor || '',
    totalBorn: record.totalBorn ?? 0,
    deaths: record.deaths ?? 0,
    location: record.location || '',
    wentWell: record.wentWell || '',
    didntGoWell: record.didntGoWell || '',
    defects: record.defects || '',
  };
}

// An edit changes only form-owned fields. Unknown historical fields and links
// survive the round trip, and the calculated count is never a second input.
export function mergeFarrowingRecord(existing: FarrowingRecord | null, form: FarrowForm, id: string): FarrowingRecord {
  return {
    ...existing,
    ...form,
    id,
    alive: (parseInt(String(form.totalBorn)) || 0) - (parseInt(String(form.deaths)) || 0),
  };
}
